import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@jsverse/transloco';

@Pipe({
    name: 'countryLabel',
    standalone: true,
})
export class CountryLabelPipe implements PipeTransform {
    transform(value: string): string {
        switch (value) {
            case 'en':
                return translate('CORE.LANGUAGE.ENGLISH');
            case 'fr':
                return translate('CORE.LANGUAGE.FRENCH');
            case 'es':
                return translate('CORE.LANGUAGE.SPANISH');
            default:
                return translate('CORE.LANGUAGE.ENGLISH');
        }
    }
}
